import Sacrificer from './sacrificer.js';
export default class Martyr extends Sacrificer
{       
    constructor(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note){ 
        super(code, id, firstName, secondName, thirdName, forthName, lastName, dateOfBirth, motherName, maritalStatus, bloodType, nationalitie, religion, doctrine, gender, note)

        // Related Data to Martyr
        this.deathCertificate   = null
        this.martyrData         = null
        this.educations         = []
        
        this.init()
    }

    setDeathCertificate(deathCertificate){
        this.deathCertificate = deathCertificate
        return this
    }

    setMartyrData(martyrData){
        this.martyrData = martyrData
        return this
    }

    setEducations(educations){
        this.educations = educations
        return this
    }
}